import React from "react";
import { gql } from "@apollo/client";
import Spinner from "react-bootstrap/Spinner";

import "./UserManagement.scss";
import Filter from "../../components/Filter/Filter";
import ArrowDown from "../../assets/icons/arrows/chevron-down.svg";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import Dropdown from "react-bootstrap/Dropdown";
import ThreeDot from "../../assets/icons/three_dots.svg";
import EmptyUsers from "../../assets/EmptyStates/empty_users.svg";
import ProfileWithName from "../../components/ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import dateFormat from "dateformat";
import AddNewUserModal from "../../components/UserManagement/AddNewUserModal/AddNewUserModal";
import InviteBulkUsersModal from "../../components/UserManagement/InviteBulkUsersModal/InviteBulkUsersModal";
import { notify } from "../../components/Notify/Notify";

import { apolloClient } from "../../index";
import { getLogin, saveLogin } from "../../auth";
import UserInvitationStatusModal from "../../components/UserManagement/UserInvitationStatusModal/UserInvitationStatusModal";
import { connect } from "react-redux";
import { mapStateToProps } from "../../common/UserDataReducer";
import EmptyStates from "../../components/EmptyStates/EmptyStates";

class UserManagement extends React.Component {
  state = {
    roles: ["", "IT Admin", "Admin", "Manager", "User", "Guest"],
    users: [],
    // {
    //   id: 1,
    //   userName: "jay",
    //   role: "Owner",
    //   addedOn: "Apr 20, 2020",
    //   emailId: "jayp@aub.com",
    //   mobileNo: "+91 1234567890",
    //   status: "Active",
    // },
    isLoading: true,
    sortByConfiguration: [{ id: "userName", desc: false }],
    showAddNewUserModal: false,
    showInviteBulkUsersModal: false,
    editMode: undefined,
    searchString: "",
  };

  customButton = React.forwardRef(({ onClick }, ref) => (
    <button
      className="dropdown custom-dropdown ic-ghost"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <img className="dropdown-toggle" src={ThreeDot} alt="Three dots" />
    </button>
  ));

  customInviteButton = React.forwardRef(({ onClick }, ref) => (
    <button
      className="btn btn-primary add-user-btn"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      Invite User
      <img className="dropdown-arrow pl-2" src={ArrowDown} alt="DownArrow" />
    </button>
  ));

  columns = [
    {
      id: "id",
      accessor: "id",
      show: false,
    },
    {
      id: "profileImage",
      accessor: "profileImage",
      show: false,
    },
    {
      Header: "User Name",
      accessor: "userName",
      sortable: true,
      Cell: ({ row }) => (
        <ProfileWithName
          sKey={row.id}
          nameIntial={
            row.userName.split(" ")[0][0] ??
            "" + row.userName.split(" ")[1][0] ??
            ""
          }
          personName={row.userName}
          profile={row.profileImage}
        />
      ),
      // width: 200,
      style: {
        overflow: "unset",
      },
    },
    {
      Header: "Role",
      accessor: "role",
      sortable: true,
    },
    {
      Header: "Added On",
      accessor: "addedOn",
      // id: "addedOn",
      // accessor: row => {
      //   return dateFormat(row.addedOn, "mmm dd, yyyy")
      // },
      sortable: true,
      sortMethod: (a, b) => {
        var a1 = new Date(a);
        var b1 = new Date(b);
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },
    },
    {
      Header: "Email Id",
      accessor: "emailId",
      sortable: true,
    },
    {
      Header: "Mobile Number",
      accessor: "mobileNo",
    },
    {
      Header: "Status",
      accessor: "status",
      sortable: true,
    },
    {
      Header: "",
      accessor: "menu",
      sortable: false,
      Cell: ({ row }) => (
        <div
          className={
            this.props.userRoleId === 1 // IT ADMIN
              ? ""
              : this.props.userRoleId === 2 // ADMIN
              ? ["IT Admin", "Admin"].includes(row.role)
                ? "hide-menu"
                : ""
              : ""
          }
        >
          <Dropdown>
            <Dropdown.Toggle as={this.customButton}></Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                as="a"
                onClick={() => this.editOnClickHandler(row)}
              >
                Edit
              </Dropdown.Item>
              {row.status === "Active" && (
                <Dropdown.Item
                  as="a"
                  onClick={(e) => {
                    // Mutation for deactivating user
                    // User Id -> row.id
                    const variables = {
                      userId: parseInt(row.id),
                    };

                    apolloClient
                      .mutate({
                        mutation: gql`
                          mutation deactivateUser($userId: Int!) {
                            deactivateUser(userId: $userId) {
                              success
                              user {
                                id
                                isActive
                              }
                            }
                          }
                        `,
                        variables: variables,
                      })
                      .then((result) => {
                        const resUser = result.data.deactivateUser.user;
                        if (result.data.deactivateUser.success) {
                          let users = [...this.state.users];

                          for (let i = 0; i < users.length; i++) {
                            if (users[i].id === resUser.id) {
                              users[i].status = resUser.isActive
                                ? "Active"
                                : "Inactive";
                            }
                          }
                          notify(
                            "Success",
                            `${row.userName} deactivated successfully.`,
                            "success"
                          );

                          this.setState({ users: users });
                        }
                      })
                      .catch((e) => {
                        // alert("Something went wrong. Please try again.");
                        const title = "Error";
                        const detail = e.message;
                        const type = "error";
                        notify(title, detail, type);
                      });
                  }}
                >
                  Deactivate Account
                </Dropdown.Item>
              )}
              {row.status === "Inactive" && (
                <Dropdown.Item
                  as="a"
                  onClick={(e) => {
                    // Mutation for activating user
                    // User Id -> row.id
                    const variables = {
                      userId: parseInt(row.id),
                    };

                    apolloClient
                      .mutate({
                        mutation: gql`
                          mutation activateUser($userId: Int!) {
                            activateUser(userId: $userId) {
                              success
                              user {
                                id
                                isActive
                              }
                            }
                          }
                        `,
                        variables: variables,
                      })
                      .then((result) => {
                        const resUser = result.data.activateUser.user;
                        if (result.data.activateUser.success) {
                          let users = [...this.state.users];

                          for (let i = 0; i < users.length; i++) {
                            if (users[i].id === resUser.id) {
                              users[i].status = resUser.isActive
                                ? "Active"
                                : "Inactive";
                            }
                          }

                          notify(
                            "Success",
                            `${row.userName} activated successfully.`,
                            "success"
                          );
                          this.setState({ users: users });
                        }
                      })
                      .catch((e) => {
                        const title = "Error";
                        const detail = e.message;
                        const type = "error";
                        notify(title, detail, type);
                      });
                  }}
                >
                  Activate Account
                </Dropdown.Item>
              )}

              <Dropdown.Item
                as="a"
                onClick={(e) => {
                  // Mutation for deleting user
                  // User Id -> row.id
                  const variables = {
                    userId: parseInt(row.id),
                  };

                  apolloClient
                    .mutate({
                      mutation: gql`
                        mutation deleteUser($userId: Int!) {
                          deleteUser(userId: $userId) {
                            success
                            user {
                              id
                              isActive
                              profile {
                                isDeleted
                              }
                            }
                          }
                        }
                      `,
                      variables: variables,
                    })
                    .then((result) => {
                      const resUser = result.data.deleteUser.user;
                      if (resUser.profile.isDeleted) {
                        let users = [...this.state.users];

                        for (let i = 0; i < users.length; i++) {
                          if (users[i].id === resUser.id) {
                            users.splice(i, 1);
                          }
                        }

                        notify(
                          "Success",
                          `${row.userName} deleted successfully.`,
                          "success"
                        );
                        this.setState({ users: users });
                      }
                    })
                    .catch((e) => {
                      const title = "Error";
                      const detail = e.message;
                      const type = "error";
                      notify(title, detail, type);
                    });
                }}
              >
                Delete Account
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      width: 50,
      style: {
        overflow: "unset",
      },
    },
  ];

  sortableHeaderMapping = {
    userName: "User Name",
    role: "Role",
    addedOn: "Added On",
    emailId: "Email Id",
    status: "Status",
  };

  componentDidMount() {
    if (!getLogin("login")) {
      const title = "Success";
      const detail = "User logged in successfully!";
      const type = "success";
      notify(title, detail, type);

      //set login true
      saveLogin("login", true);
    }
    apolloClient
      .query({
        query: gql`
          query usersOfCustomer {
            usersOfCustomer(roleIds: [1, 2, 3, 4, 5]) {
              id
              mobileNumber
              image
              user {
                id
                username
                firstName
                lastName
                email
                isActive
                dateJoined
              }
              role {
                id
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const usersOfCustomer = result.data.usersOfCustomer;
        const updatedUsers = usersOfCustomer.map((usr) => {
          return {
            id: usr.user.id,
            userName: usr.user.firstName + " " + usr.user.lastName,
            role: this.state.roles[usr.role.id],
            addedOn: dateFormat(usr.user.dateJoined, "mmm dd, yyyy"),
            emailId: usr.user.email,
            mobileNo: usr.mobileNumber ? usr.mobileNumber : "-",
            status: usr.user.isActive ? "Active" : "Inactive",
            profileImage: usr.image,
          };
        });
        this.setState({
          isLoading: false,
          users: [
            ...updatedUsers,
            // ...this.state.users,
            // ...this.state.users,
            // ...this.state.users,
            // ...this.state.users,
          ],
        });
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  }

  getFilteredUsers(roleIds) {
    apolloClient
      .query({
        query: gql`
          query usersOfCustomer($roleIds: [Int!]!) {
            usersOfCustomer(roleIds: $roleIds) {
              id
              image
              mobileNumber
              user {
                id
                username
                firstName
                lastName
                email
                isActive
              }
              role {
                id
              }
            }
          }
        `,
        variables: { roleIds: roleIds },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const usersOfCustomer = result.data.usersOfCustomer;
        if (usersOfCustomer.length > 0) {
          const updatedUsers = usersOfCustomer.map((usr) => {
            return {
              id: usr.user.id,
              userName: usr.user.firstName + " " + usr.user.lastName,
              role: this.state.roles[usr.role.id],
              addedOn: "Apr 20, 2020",
              emailId: usr.user.email,
              mobileNo: usr.mobileNumber ? usr.mobileNumber : "-",
              status: usr.user.isActive ? "Active" : "Inactive",
              profileImage: usr.image,
            };
          });

          this.setState({
            isLoading: false,
            users: [
              ...updatedUsers,
              // ...this.state.users,
              // ...this.state.users,
              // ...this.state.users,
              // ...this.state.users,
            ],
          });
        } else {
          this.setState({
            isLoading: false,
            users: [],
          });
        }
      })
      .catch((e) => {
        const title = "Error";
        const detail = "Oops!! some error occurred please try again.";
        const type = "error";
        notify(title, detail, type);
      });
  }

  handleSortChange = (data) => {
    this.setState({
      sortByConfiguration: data,
    });
  };

  editOnClickHandler = (row) => {
    this.setState({
      editMode: {
        email: row.emailId,
        role: row.role,
        id: row.id,
      },
      showAddNewUserModal: true,
    });
  };

  updateUserRole = (userId, roleId) => {
    const allUsers = [...this.state.users];

    for (let i = 0; i < allUsers.length; i++) {
      if (allUsers[i].id === userId) {
        allUsers[i].role = this.state.roles[roleId];
      }
    }
    this.setState({ users: allUsers });
  };

  searchFilteredUsers = () =>
    this.state.users.filter((user) =>
      // Apply text search filter
      user.userName
        .toLowerCase()
        .includes(this.state.searchString.trim().toLowerCase())
    );

  render() {
    return (
      <div className="container-fluid user-management-wraper">
        <div className="user-management-body">
          <div className="sub-header d-flex">
            <div className="search-filter-container">
              <div className="search-box mr-2">
                <input
                  type="text"
                  maxLength="50"
                  placeholder="&#xF002;  Search Users"
                  className="search-placeholder set-width"
                  value={this.state.searchString}
                  onChange={(e) => {
                    this.setState({ searchString: e.target.value });
                    // handleFilterTags();
                  }}
                />
              </div>
              <Filter
                isUserView={true}
                categories={{
                  Roles: ["IT Admin", "Admin", "Manager", "User", "Guest"],
                }}
                filterApplyHandler={(appliedFilterConfiguration) => {
                  let roleIds = [];
                  if (
                    appliedFilterConfiguration["Roles"] &&
                    appliedFilterConfiguration.Roles.length > 0
                  ) {
                    roleIds = appliedFilterConfiguration.Roles.map((role) => {
                      if (role.toLowerCase() === "it admin") {
                        return 1;
                      }

                      if (role.toLowerCase() === "admin") {
                        return 2;
                      }

                      if (role.toLowerCase() === "manager") {
                        return 3;
                      }

                      if (role.toLowerCase() === "user") {
                        return 4;
                      }

                      if (role.toLowerCase() === "guest") {
                        return 5;
                      }
                      return 6;
                    });
                  }
                  if (roleIds.length > -1) {
                    this.getFilteredUsers(roleIds);
                  }
                }}
              />
            </div>

            <UserInvitationStatusModal />

            <Dropdown alignRight>
              <Dropdown.Toggle
                as={this.customInviteButton}
                id="dropdown-custom-components"
              ></Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  as="a"
                  onClick={() =>
                    this.setState({
                      showAddNewUserModal: true,
                      editMode: undefined,
                    })
                  }
                >
                  Single Invite
                </Dropdown.Item>
                <Dropdown.Item
                  as="a"
                  onClick={() => {
                    this.setState({ showInviteBulkUsersModal: true });
                  }}
                >
                  Bulk Invite
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="user-table">
            {this.state.isLoading ? (
              <div style={{ textAlign: "center" }}>
                <div className="progress-icon" style={{ textAlign: "center" }}>
                  <Spinner animation="border" role="status" />
                </div>
              </div>
            ) : this.searchFilteredUsers().length === 0 ? (
              <div className="no-users is-size-h2 bold">
                <EmptyStates
                  imgSrc={EmptyUsers}
                  emptyStateTitle="No results found !"
                  description="Please try again using different filters or search terms"
                  emptyStateButtons={[]}
                />
              </div>
            ) : (
              <ReactTable
                data={this.searchFilteredUsers()}
                columns={this.columns}
                noDataText={"No user found."}
                pageSize={this.state.users.length}
                showPagination={false}
                minRows={0}
                sortable={false}
                sorted={this.state.sortByConfiguration}
                onSortedChange={this.handleSortChange}
                // loading={this.state.isLoading}
                resizable={false}
              />
            )}
          </div>
        </div>

        <AddNewUserModal
          showModal={this.state.showAddNewUserModal}
          handleClose={() => this.setState({ showAddNewUserModal: false })}
          editMode={this.state.editMode}
          updateUserRole={this.updateUserRole}
          currentUserId={this.props.currentUserId}
        />

        <InviteBulkUsersModal
          showModal={this.state.showInviteBulkUsersModal}
          currentUserId={this.props.currentUserId}
          handleClose={() => this.setState({ showInviteBulkUsersModal: false })}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(UserManagement);
